export default "__VITE_ASSET___a5Zmu1J__"